import axios from "axios";

class ClientService {
  api;
  constructor() {
    this.api = axios.create({
      // Asegúrate de que la URL base incluya el prefijo correcto, en este caso "/api/v1"
      baseURL: process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1",
    });
    // Interceptor para agregar el token a cada petición
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem("Token");
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Token ${token}`,
          withCredentials: false,
          "Content-Type": "application/json; charset=UTF-8",
        };
      }
      return config;
    });
  }

  // Obtiene la lista paginada de clientes con filtros y límite opcionales
  async getClientListPaginate(page = 1, filters = {}, limit = 10) {
    try {
      const response = await this.api.get("/client/client-list/", {
        params: { page, limit, ...filters },
      });
   
      if (Array.isArray(response.data)) {
        return { results: response.data, count: response.data.length };
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Método para obtener los detalles de un cliente
  async getClientDetails(clientId) {
    try {
      const response = await this.api.get(`/client/${clientId}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  } 
  async getClientListDetails(clientId) {
    try {
      const response = await this.api.get(`/client/client-list-details/${clientId}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Actualiza un cliente por su ID
  async updateClient(clientId, clientData) {
    try {
      const response = await this.api.put(`/client/${clientId}/update-client/`, clientData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  
  // Crea un nuevo cliente
  async createClient(clientData) {
    try {
      const response = await this.api.post("/client/", clientData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Elimina un cliente por su ID
  async deleteClient(clientId) {
    try {
      return await this.api.delete(`/client/${clientId}/`);
    } catch (error) {
      throw error;
    }
  }

  // Importa clientes desde un archivo (CSV o Excel)
  async importClient(formData) {
    try {
      return await this.api.post("/client/import/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    } catch (error) {
      throw error;
    }
  }

  // Exporta la lista de clientes (con o sin asignación)
  async exportClient(is_assigned = false) {
    try {
      return await this.api.get("/client/export/", {
        params: { is_assigned },
        responseType: "blob",
      });
    } catch (error) {
      throw error;
    }
  }
  async getLawyerList() {
    try {
      const response = await this.api.get("/lawyer/");
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  // Obtiene la lista de especialidades para clientes
  async getSpecialtyList() {
    try {
      const response = await this.api.get("/specialty/");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Obtiene la lista de provincias para clientes
  async getProvinceList() {
    try {
      const response = await this.api.get("/province/");
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new ClientService();
